import { nextTick } from 'vue';
import { Capacitor } from '@capacitor/core';
import { AppUpdate, AppUpdateAvailability } from '@capawesome/capacitor-app-update';
import store from '@/store';

export const checkAppVersion = async app_version_minimal => {
    if (Capacitor.isNativePlatform() && app_version_minimal) {
        const options = Capacitor.getPlatform() === 'ios' ? { country: 'ES' } : null;
        try {
            const result = await AppUpdate.getAppUpdateInfo(options);

            if (result.updateAvailability !== AppUpdateAvailability.UPDATE_AVAILABLE) return;

            if (Capacitor.getPlatform() === 'android' && result.immediateUpdateAllowed) {
                setAppVersionMinimal(app_version_minimal);
            } else if (Capacitor.getPlatform() === 'ios') {
                // en ios no podemos si esta disponible la nueva versión de la app en la store
                setAppVersionMinimal(app_version_minimal);
            }
        } catch (error) {
            console.error({ error });
            return;
        }
    }
};

// Esto lo hacemos para forzar sí o sí la actualización de la app, si por lo que sea, se lanza el cambio en la store la 1ª vez y
// se saltan el modal de alguna forma (por algún tipo de error), la siguiente vez que se actualice el valor de la store, no se lanzará
// el modal, porque el valor no cambio. Poniendo el valor a null, y en el nextTick ponemos la versión, forzamos a que se recalcule el valor
// de los computed.
const setAppVersionMinimal = app_version_minimal => {
    store.dispatch('setAppVersionMinimal', null);
    nextTick(() => {
        store.dispatch('setAppVersionMinimal', app_version_minimal);
    });
};
